import { Navigate, Route } from "react-router";
import { CompanySettingsLayout } from "./CompanySettingsLayout";
import { ProfileSettings } from "./Profile/ProfileSettings";
import { useFoodpilotContext, VIEW_ORG_SETTINGS, ORGANIZATION } from "src/context/FoodpilotContext";

const CompanySettingsGuard = () => {
    const { canUser } = useFoodpilotContext();

    if (!canUser(VIEW_ORG_SETTINGS, ORGANIZATION)) {
        return <Navigate to="/" replace />;
    }

    return <CompanySettingsLayout />;
};

export const useCompanySettingsRouter = () => {
    return (
        <Route path="company-settings" element={<CompanySettingsGuard />}>
            <Route index element={<ProfileSettings />} />
        </Route>
    );
};
